import { ScenarioLayer } from "@nens/rana/api-v1";

export function getScenarioLayerByCode(
  layers: ScenarioLayer[] | undefined,
  code: string | null
): ScenarioLayer | undefined {
  if (!code) return undefined;
  return layers?.find((layer) => layer.code === code);
}
